<div class="found-no-results">
	<div class="found-no-results__title">{{ "savings_plan_with_plans_filter_no_results_title" | translate }}</div>
	<div class="found-no-results__description">
		{{ "savings_plan_with_plans_filter_no_results_description" | translate }}
	</div>
</div>
